export default __webpack_public_path__ + "static/dev-floorplan-4ed0f657e1a1260df982111068a6f048.jpg";